export default __webpack_public_path__ + "src/assets/cd3a730549789d49589d.webp";